import React from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import Config from "conFig.js";
import { Error, Success } from "../../../assets/jss/util/messageUtil";

export default function Themlaixe() {
  const [hoten, setHoten] = React.useState("");
  const [ngaysinh, setNgaysinh] = React.useState(dayjs());
  const [cmnd, setCmnd] = React.useState("");
  const [cmndget, setCmndget] = React.useState("");
  const [ngaycapcmnd, setNgaycapcmnd] = React.useState(dayjs());
  const [diachi, setDiachi] = React.useState("");
  const [sodienthoai, setSodienthoai] = React.useState("");
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const [alert2, setAlert2] = React.useState(false);
  const [alertValidate, setAlertValidate] = React.useState(false);
  const [messageValidate, setMessageValidate] = React.useState("");
  //const [disableBT, setDisableBT] = React.useState(true);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getlaixetheocmnd = () => {
    var url =
      Config.backend +
      "/api/Donvi/getlaixetheocmnd?cmnd=" +
      cmndget +
      "&username" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        if (data[0]) {
          if (data[0].hoten) setHoten(data[0].hoten);
          if (data[0].cmnd) setCmnd(data[0].cmnd);
          if (data[0].diachi) setDiachi(data[0].diachi);
          if (data[0].sodienthoai) setSodienthoai(data[0].sodienthoai);
          if (data[0].ngaysinh) {
            let [day, month, year] = data[0].ngaysinh.split("-");
            setNgaysinh(dayjs(year + "-" + month + "-" + day));
          }
          if (data[0].ngaycapcmnd) {
            let [day1, month1, year1] = data[0].ngaycapcmnd.split("-");
            setNgaycapcmnd(dayjs(year1 + "-" + month1 + "-" + day1));
          }
        } else {
          showNotification1();
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const insertlaixe = () => {
    let mess = validateThem();
    if (mess === Success.SC0001) {
      var ngaythangsinh =
        ngaysinh.$y +
        "-" +
        String(ngaysinh.$M + 1).padStart(2, "0") +
        "-" +
        ngaysinh.$D;
      var ngaycapcm =
        ngaycapcmnd.$y +
        "-" +
        String(ngaycapcmnd.$M + 1).padStart(2, "0") +
        "-" +
        ngaycapcmnd.$D;
      var url = Config.backend + "/api/Donvi/themlaixe";
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          hoten: hoten,
          ngaysinh: ngaythangsinh,
          cmnd: cmnd,
          sodienthoai: sodienthoai,
          ngaycapcmnd: ngaycapcm,
          diachi: diachi,
          username: username,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data === 1) {
            showNotification();
          } else showNotification2();
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    } else {
      setMessageValidate(mess);
      showNotificationValidate();
    }
  };
  const showNotificationValidate = () => {
    setAlertValidate(true);
    setTimeout(function () {
      setAlertValidate(false);
    }, 6000);
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  const showNotification2 = () => {
    setAlert2(true);
    setTimeout(function () {
      setAlert2(false);
    }, 2000);
  };
  // const disablebutton = () => {
  //   if (cmnd.trim().length > 0 && hoten.trim().length > 0) {
  //     setDisableBT(false);
  //   } else {
  //     setDisableBT(true);
  //   }
  // };
  // React.useEffect(() => {
  //   disablebutton();
  // }, [hoten, cmnd]);
  const validateThem = () => {
    // Kiem tra cac truong bat buoc nhap
    if (cmnd.trim() === "") {
      return Error.ER0061;
    }
    if (hoten.trim() === "") {
      return Error.ER0062;
    }
    return Success.SC0001;
  };
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridItem xs={12} sm={12} md={12}>
          <FormControl style={{ width: "40%" }}>
            <TextField
              label="Số CMND/CCCD"
              variant="outlined"
              size="small"
              value={cmndget}
              onChange={(event) => {
                setCmndget(event.target.value.trim());
              }}
              InputProps={{
                style: {
                  height: "35px",
                },
              }}
            />
          </FormControl>
          <FormControl style={{ width: "40%", marginLeft: 10 }}>
            <Button
              color="warning"
              variant="contained"
              style={{ height: 35 }}
              onClick={getlaixetheocmnd}
            >
              Lấy thông tin
            </Button>
          </FormControl>
        </GridItem>
      </CardBody>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Họ tên"
                variant="outlined"
                size="small"
                value={hoten}
                onChange={(event) => {
                  setHoten(event.target.value);
                }}
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày tháng năm sinh"
                  value={ngaysinh}
                  format="DD/MM/YYYY"
                  onChange={(newValue) => {
                    setNgaysinh(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Số điện thoại"
                variant="outlined"
                size="small"
                value={sodienthoai}
                onChange={(event) => {
                  setSodienthoai(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Số CMND/CCCD"
                variant="outlined"
                size="small"
                value={cmnd}
                onChange={(event) => {
                  setCmnd(event.target.value);
                }}
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày cấp CMND/CCCD"
                  value={ngaycapcmnd}
                  format="DD/MM/YYYY"
                  onChange={(newValue) => {
                    setNgaycapcmnd(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Địa chỉ"
                variant="outlined"
                size="small"
                value={diachi}
                onChange={(event) => {
                  setDiachi(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      {/** fix css */}
      <CardFooter style={{ marginBottom: "20px" }}>
        <Button
          color="primary"
          variant="contained"
          //disabled={disableBT}
          style={{ height: 27 }}
          onClick={insertlaixe}
        >
          Thêm
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Thêm thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Không tìm thấy thông tin lái xe"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Có lỗi trong quá trình thêm"
            open={alert2}
            closeNotification={() => setAlert2(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message={messageValidate}
            open={alertValidate}
            closeNotification={() => setAlertValidate(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
}
